import React, { useState } from "react";
import FileBrowser from "../../shared/fileBrowser/FileBrowser";
import PreviewTermsConditions from "../../shared/previewTermsConditions/PreviewTermsConditions";
import Button from "@mui/material/Button";
import styles from "./UploadTermsConditions.module.scss";
import Grid from "@mui/material/Grid";
import { InfoIconWithMessage } from "../../shared/infoIcon/InfoIcon";
import { withTranslation } from "react-i18next";

const UploadTermsConditions = (props) => {
  const [file, setFile] = useState(null);
  const [displayPreview, setDisplayPreview] = useState(false);
  const [displayError, setDisplayError] = useState(false);

  const onFileSelected = (selectedFile) => {
    if (
      selectedFile.size > 1000000 ||
      selectedFile.type !== "application/pdf"
    ) {
      setDisplayError(true);
      setFile(null);
      setDisplayPreview(false);
      props.showActionFooter(false);
      props.updateParentState({
        file: null,
        displayError: true,
        displayPreview: false,
      });
    } else {
      setFile(selectedFile);
      setDisplayPreview(true);
      setDisplayError(false);
      props.showActionFooter(true);
      props.updateParentState({
        file: selectedFile,
        displayPreview: true,
        displayError: false,
      });
    }
  };

  return (
    <section className="pageWrapper" id="uploadTermsAndConditions">
      <div className="pagePadding">
        <h1 className="pageTitle">{props.t("UploadTermsConditions.header")}</h1>
        <div className="pageInfoWrapper">
          <InfoIconWithMessage
            message={props.t("UploadTermsConditions.bodyCopy")}
          />
        </div>

        {displayPreview ? (
          <div>
            <p>{props.t("UploadTermsConditions.uploadedFile")}</p>

            <Grid container spacing={24}>
              <Grid item xs={12} md={12}>
                <PreviewTermsConditions
                  file={file}
                  className={styles.previewPDF}
                />
              </Grid>
            </Grid>
            <div className={styles.changeFile}>
              <span className={styles.tick}>&#10003;</span>
              <span className={styles.uploadEMPTerms}>
                {props.t("UploadTermsConditions.uploadButton")}
              </span>
              <FileBrowser
                fileType=".pdf"
                onFileSelected={onFileSelected}
                id="pdf-file"
              >
                <Button className={`${styles.changeBtn}`} component="span">
                  {props.t("UploadTermsConditions.change")}
                </Button>
              </FileBrowser>
            </div>
            <p className={styles.fileTypetext}>
              {props.t("UploadTermsConditions.tipText")}
            </p>
          </div>
        ) : (
          <div>
            <FileBrowser
              fileType=".pdf"
              onFileSelected={onFileSelected}
              id="pdf-file"
            >
              <Button
                className={styles.uploadBtn}
                component="span"
                id="upload-file-btn"
              >
                {props.t("UploadTermsConditions.uploadButton")}
              </Button>
            </FileBrowser>
            <p className={styles.fileTypetext}>
              {props.t("UploadTermsConditions.tipText")}
            </p>
            {displayError && (
              <div className={styles.warningDiv}>
                <div className={styles.warning}></div>
                <div className={styles.errorText}>
                  {props.t("Error.fileError")}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default withTranslation("emp")(UploadTermsConditions);
